import { useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

//Bootstrap
import { Form } from "react-bootstrap";

//API calls
import {
  useGetSifrantVlogaPartnerja,
  useEditPartnerUM,
} from "../../../../services/ProjectDetails/partnerskeOrganizacijeAPI";
import { useGetOsebeFromImenik } from "../../../../services/Shared/sharedAPI";

//UI components
import FormSelect from "../../../ui/FormSelect";
import FormSelectSearchAsyncField from "../../../ui/FormSelectSearchAsyncField";
import ErrorMessage from "../../../ui/ErrorMessage";

//Utils
import { useDebounceHook } from "../../../utils/useDebounceHook";
import sifrantSetSelectValueAndLabel from "../../../utils/sifrantSetSelectValueAndLabel";

//Validation schema
import formEditPartnerUMSchema from "../../../../config/formEditPartnerUM";

const PartnerUMEditForm = ({ partnerUM, setIsEditing }) => {
  const { id } = useParams();

  const [searchTermOseba, setSearchTermOseba] = useState("");

  const schema = useMemo(() => formEditPartnerUMSchema, []);

  //GET Vloge za partnerja
  const { data: sifrantVloga } = useGetSifrantVlogaPartnerja(true);

  //GET osebe from Imenik based on search term
  const { data: osebeImenik, isLoading: isLoadingOsebe } =
    useGetOsebeFromImenik(useDebounceHook(searchTermOseba, 300));

  //PUT edit UM partner
  const {
    mutate: editPartnerUM,
    isPending: isPendingEdit,
    isError,
    error,
    reset: resetMutationError,
  } = useEditPartnerUM(id);

  //INIT form with react-hook-form and zod validation
  const {
    handleSubmit,
    formState: { errors, isDirty },
    control,
  } = useForm({
    resolver: zodResolver(schema),
    defaultValues: {
      vlogaID: partnerUM?.vlogaID || null,
      osebaSelected:
        partnerUM?.kisID && partnerUM?.kisID !== 0
          ? { value: partnerUM.kisID, label: partnerUM.vodjaProjektaNaUM }
          : null,
    },
  });

  //setSifrantVlogaOptions in format for select component
  const sifrantVlogaOptions = sifrantSetSelectValueAndLabel(sifrantVloga);

  //setOsebeOptions in format for select component
  const osebeOptions = sifrantSetSelectValueAndLabel(
    osebeImenik,
    "kisid",
    "naziv",
  );

  //onSubmit function to call mutation for editing UM partner
  const onSubmit = (data) => {
    const payload = {
      vlogaID: data.vlogaID,
      kisID: data.osebaSelected.value,
      vodjaProjektaNaUM: data.osebaSelected.label,
    };

    editPartnerUM(payload, {
      onSuccess: () => {
        setIsEditing(false);
      },
      onError: () => setTimeout(() => resetMutationError(), 3000),
    });
  };

  return (
    <div className="px-3 pb-3 mt-2">
      <Form onSubmit={handleSubmit((data) => onSubmit(data))}>
        <FormSelect
          label="Vloga partnerja"
          name="vlogaID"
          control={control}
          options={sifrantVlogaOptions}
          validationError={errors.vlogaID?.message}
        />
        <FormSelectSearchAsyncField
          label="Vodja projekta na UM"
          name="osebaSelected"
          control={control}
          options={osebeOptions}
          setSearchTerm={setSearchTermOseba}
          placeholder="Iskanje vodje projekta na UM..."
          isLoading={isLoadingOsebe}
          validationError={errors.osebaSelected?.message}
        />
        <button
          type="submit"
          className="btn btn-primary mt-3"
          disabled={!isDirty || isPendingEdit}
        >
          {isPendingEdit ? "Shranjevanje..." : "Shrani"}
        </button>
        <button
          type="button"
          className="btn btn-secondary mt-3 ms-2"
          onClick={() => setIsEditing(false)}
        >
          Prekliči
        </button>
        {isError && <ErrorMessage message={error.message} />}
      </Form>
    </div>
  );
};

export default PartnerUMEditForm;
